import React from 'react'

const HomepageContent = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 text-center leading-tight">
          Understanding Water Damage: A Homeowner&apos;s Guide
        </h2>
        <div className="grid md:grid-cols-2 gap-x-8 gap-y-6 text-gray-700">
          <div>
            <h3 className="text-xl font-semibold mb-2 text-gray-800">Common Causes of Water Damage</h3>
            <p>
              Water damage can strike unexpectedly from a variety of sources. Homeowners most frequently encounter issues from burst pipes during cold snaps, slow leaks from appliances like dishwashers or washing machines, and failed water heaters. Beyond plumbing, the structure of your home can be a vulnerability; clogged gutters can cause roof leaks, and cracks in the foundation can allow groundwater to seep in. And of course, severe weather events and natural disasters like floods can lead to catastrophic water intrusion.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2 text-gray-800">The Hidden Dangers: More Than Just Wet Floors</h3>
            <p>
              The visible damage is often just the beginning. Once water permeates your home, it creates a cascade of secondary problems. It can saturate insulation, weaken structural components like drywall and wooden studs, and compromise your home&apos;s electrical system, creating serious safety hazards. The most urgent threat, however, is mold. In a damp environment, mold can begin to colonize in as little as 24 to 48 hours, posing significant health risks, especially for individuals with allergies or respiratory issues.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2 text-gray-800">Our Professional Restoration Process: What to Expect</h3>
            <p>
              When you call a professional, you&apos;re initiating a proven process to make your home safe and sound again. The first step is always a thorough assessment, followed by immediate water extraction using powerful pumps and vacuums. Next, technicians deploy industrial-grade air movers and dehumidifiers to meticulously dry the structure, flooring, and any affected belongings. The final stage is restoration, which can range from cleaning and sanitizing to repairing or rebuilding damaged sections of your home to its pre-loss condition.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2 text-gray-800">Why Immediate Action is Crucial</h3>
            <p>
              Prompt action is crucial in the event of water damage because delays can worsen the situation. As time elapses, water can permeate more deeply, exacerbating structural harm and raising the risk of severe mold growth. Swift response helps limit these damages, simplify the restoration process, and cut down on costs. Calling a round-the-clock emergency service is essential for safeguarding both your property and your well-being.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomepageContent
